// extracted by mini-css-extract-plugin
export default {"select_itemsWrapper":"styleInputSearch_select_itemsWrapper__f1eSR","select_item":"styleInputSearch_select_item__S5Bab"};